import 'core-js/proposals/explicit-resource-management';

import { createLogger, loggerStyles } from '@ricoh/ria.client.core/plugins/app/logger';

const logger = createLogger('app/es');

/** Import Polyfills. */
export function importPolyfills() {
  logger.write('info', `${loggerStyles.responseText('Import')} polyfills`);
}
